import FilterItem from "../../../views/components/reuseComp/FilterSection";
import { useEffect, useState } from "react";

export const FillingManagementFilterMenu = ({
  selectedFilters,
  setSelectedFilters,
}: {
  selectedFilters: Record<string, string>;
  setSelectedFilters: (v: any) => void;
}) => {
  const [openKey, setOpenKey] = useState<string | null>(null);

  const toggle = (key: string) => {
    setOpenKey((prev) => (prev === key ? null : key));
  };

  const setFilter = (key: string, value: string) => {
    setSelectedFilters((prev: any) => ({
      ...prev,
      [key]: value, // overwrite previous selection
    }));
  };



  return (
    <div className="w-60 p-4 rounded-xl bg-[#F7E4D4] custom_shadow">
      <FilterItem
        label="Filling year"
        keyName="filling_year"
        selectedValue={selectedFilters.filling_year}
        isOpen={openKey === "filling_year"}
        onClick={() => toggle("filling_year")}
        options={["2025-26", "2026-27"]}
        onSelect={setFilter}
      />

      <FilterItem
        label="Status"
        keyName="status"
        selectedValue={selectedFilters.status}
        isOpen={openKey === "status"}
        onClick={() => toggle("status")}
        options={["DRAFT", "SUBMITTED", "PAID"]}
        onSelect={setFilter}
      />

      <FilterItem
        label="Filling Type"
        keyName="filling_type"
        selectedValue={selectedFilters.filling_type}
        isOpen={openKey === "filling_type"}
        onClick={() => toggle("filling_type")}
        options={["ANNUALLY", "QUARTERLY"]}
        onSelect={setFilter}
      />

      <FilterItem
        label="Complexity"
        keyName="complexityLevel"
        selectedValue={selectedFilters.complexityLevel}
        isOpen={openKey === "complexityLevel"}
        onClick={() => toggle("complexityLevel")}
        options={["LOW", "MEDIUM", "HIGH"]}
        onSelect={setFilter}
      />
    </div>
  );
};
